export default {
  state: {
    locales: {
      hy: 'ARM',
      en: 'ENG',
      ru: 'RUS'
    },
    page_params: {
      product: {
        last_views: []
      }
    },
    navigation: []
  },
  mutations: {
    SET_LAST_VIEWS (state, product_id) {
      if (state.page_params.product.last_views.length >= 10) {
        state.page_params.product.last_views.pop()
      }
      state.page_params.product.last_views.unshift(product_id)
    },
    SET_NAVIGATION (state, navigation) {
      state.navigation = navigation
    }
  },
  actions: {
    fetchLastViews ({ commit, getters }, product_id) {
      if (!getters.checkLastViewItem(product_id)) {
        commit('SET_LAST_VIEWS', product_id)
      }
    },
    fetchNavigation ({ commit }, navigation) {
      commit('SET_NAVIGATION', navigation)
    }
  },
  getters: {
    checkLastViewItem: state => product_id => {
      return state.page_params.product.last_views.includes(product_id)
    }
  }
}
